import { CompositeField, SelectField, DeleteButton } from "../../../../shared";
import { Row, Col, Input, Form, Checkbox, Skeleton, Alert, Button, Empty, Popover, Tooltip } from "antd";
import { implementer } from "../../../../../helpers/selectOptions";
import { LinkOutlined, QuestionCircleFilled } from "@ant-design/icons"
import { UploadButtonForm } from "../../../../shared";
import { toFileList } from "../../../../../helpers";
import { useEffect, useState } from "react";

export function GovernmentForm({ data, isLoading, onChange, error, disabled }) {

  const [lastModified, setLastModified] = useState("")

  useEffect(() => {

    if (data?.Implementer?.councilMembers) {

      const members = data?.Implementer?.councilMembers ?? [];

      const mostRecent = members.length > 0
        ? members.reduce((latest, item) =>
            new Date(item.modifiedAt) > new Date(latest.modifiedAt) ? item : latest
          )
        : null;

      if (!mostRecent?.modifiedAt) {
        setLastModified("");
        return;
      }

      const date = new Date(mostRecent.modifiedAt);
      const formatted =
        String(date.getDate()).padStart(2, "0") + "/" +
        String(date.getMonth() + 1).padStart(2, "0") + "/" +
        date.getFullYear();

      setLastModified(formatted);
    }

  }, [data])

  if (isLoading) {
    return <Skeleton active />
  }

  if (!data || error) {
    return (
      <Alert
        message="Error"
        description="Ha ocurrido un error al cargar los datos de esta sección,
        por favor actualiza la página."
        type="error"
        showIcon />
    )
  }


  const onDoneFile = (files, updateItem, index) => {
    const documents = files?.map(({ name, url }) => ({ name, url, type: "Semblanza" }))

    updateItem(index)(
      {
        target: {
          name: "documents",
          value: documents,
        },
      }
    )
  }

  const onRemoveFile = ({ url }, files, updateItem, index) => {
    const documents = files?.filter(doc => doc.url !== url)

    updateItem(index)({
      target: {
        name: "documents",
        value: documents,
      },
    })
  }



  const content = (documents, index, updateItem) => (
    <div style={{ width: "300px", height: "150px", overflowX: "hidden", overflowY: "scroll" }}>
      <>
        <p>Documentos</p>
        <UploadButtonForm
          fileList={toFileList(documents)}
          onRemoveFile={data => onRemoveFile(data, documents, updateItem, index)}
          onChange={file => onDoneFile(file, updateItem, index)}
          maxFile={1}
        >
          Adjuntar
        </UploadButtonForm>
      </>
    </div>
  )

  const onChangeList = (data) => {
    const cleanData = data.map(({ modifiedAt, ...rest }) => ({
      ...rest
    }));
    onChange(cleanData)
  }

  const helpText = <>Semblanza Curricular <br /> (máximo 2 páginas que incluya): <br /> Fotografía <br /> Experiencia profesional: su campo de trabajo actual y pasado.
    <br /> Formación académica: su preparación profesional. <br /> Experiencia en el sector social: si han participado en otros consejos o voluntariados.
    <br /> Afiliaciones: a qué cámaras, colegios profesionales o empresas pertenecen.</>

  return (
    <Form layout="vertical">
      <Form.Item
        label={<>
          <p>Incluye nombres y cargos del consejo directivo.<br />
            Fecha de última actualización: <strong>{lastModified}</strong>
          </p>
        </>}
        style={{ display: "inline" }}>
        <CompositeField
          onChange={onChangeList}
          defaultValue={[...(data?.Implementer?.councilMembers || [])].sort((a, b) =>
            a?.name?.toLowerCase()?.localeCompare(b?.name?.toLowerCase())
          )}
          onClickAdd={(addNew) => addNew({ name: "", charge: "", email: "", phone: "", remuneration: false, documents: [] })}
          addLabel="Agregar directivo"
          isAddDisabled={disabled}>
          {({ items, updateItemGobernanza, removeItem }) =>
            <div>
              {items?.map((item, index) =>
                <Row key={`${item.name}-${index}`} gutter={[10, 8]} justify="start">
                  <Col span={4}>
                    <Form.Item
                      style={{ display: "inline" }}
                      label="Nombre">
                      <Input
                        id="name"
                        name="name"
                        defaultValue={item.name}
                        onBlur={updateItemGobernanza(index)}
                        type="text"
                        disabled={disabled} />
                    </Form.Item>
                  </Col>
                  <Col span={4}>
                    <Form.Item
                      style={{ display: "inline" }}
                      label="Cargo">
                      <SelectField
                        id="charge"
                        name="charge"
                        defaultValue={item.charge}
                        onChange={updateItemGobernanza(index)}
                        options={implementer.profile.chargeTypes}
                        disabled={disabled} />
                    </Form.Item>
                  </Col>
                  <Col span={4}>
                    <Form.Item
                      style={{ display: "inline" }}
                      label="Correo Electronico">
                      <Input
                        id="email"
                        name="email"
                        defaultValue={item.email}
                        onBlur={updateItemGobernanza(index)}
                        type="text"
                        disabled={disabled} />
                    </Form.Item>
                  </Col>
                  <Col span={4}>
                    <Form.Item
                      style={{ display: "inline" }}
                      label="Celular">
                      <Input
                        id="phone"
                        name="phone"
                        defaultValue={item.phone}
                        onBlur={updateItemGobernanza(index)}
                        type="text"
                        disabled={disabled} />
                    </Form.Item>
                  </Col>
                  <Col span={4}>
                    <Form.Item
                      style={{ display: "inline" }}
                      label=" ">
                      <Checkbox
                        id="remuneration"
                        name="remuneration"
                        onChange={event => {
                          event.target.value = event.target.checked
                          updateItemGobernanza(index)(event)
                        }}
                        defaultChecked={item.remuneration}
                        disabled={disabled}>
                        No recibe remuneración
                      </Checkbox>
                    </Form.Item>
                  </Col>
                  <Col span={2}>
                    <Form.Item
                      style={{ display: "inline" }}
                      label={
                        <Tooltip title={helpText}>
                          Semblanza <QuestionCircleFilled style={{ fontSize: "12px" }} />
                        </Tooltip>
                      }
                    >
                      <Popover
                        id="documents"
                        name="documents"
                        placement="right"
                        content={content(item.documents ?? [], index, updateItemGobernanza)}
                        title={""}
                        trigger="click">
                        <Button
                          shape="circle"
                          icon={<LinkOutlined />} />
                      </Popover>
                    </Form.Item>
                  </Col>
                  <Col span={2}>
                    <Form.Item
                      style={{ display: "inline" }}
                      label=" ">
                      {!disabled && <DeleteButton onClick={removeItem(index)} />}
                    </Form.Item>
                  </Col>
                </Row>
              )}
              {!items.length ?
                <Empty
                  style={{ marginBottom: "10px" }}
                  description="Agrega directivos haciendo click en el botón de abajo" />
                : null}
            </div>
          }
        </CompositeField>
      </Form.Item>
    </Form>
  )
}
